__webpack_require__.p = "https://s2.blofin.com/frontend/_support_website/_next/";